import { Box, Button, Typography } from '@mui/material'
import notfoudImg from 'assets/not-found.svg'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export const NotFound: React.FC = () => {
    const navigate = useNavigate()

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={`calc(100vh - 4rem)`}
            flexDirection="column"
            gap={1}
        >
            <img src={notfoudImg} alt="" width="60" />
            <Typography variant="h6">Página não encontrada</Typography>
            <Typography variant="subtitle1">
                talvez você esteja acessando um recurso inexistente ou não que
                tenha autorização.
            </Typography>
            <br />
            <Button
                variant="outlined"
                color="primary"
                onClick={() => navigate('/')}
            >
                Voltar para o início
            </Button>
        </Box>
    )
}
